module.exports = __webpack_public_path__ + "static/hero-background-75d23fd58f54a2bf059b28aed5b5000b.jpg";